import { swatchTemplate } from "../templates";

var SwatchView = Backbone.View.extend({
    tagName: 'div',
    className: 'swatch',
    initialize: function(options) {
        this.options = options;
        _.bindAll( this, 'render', 'cleanup' );
        this.bind( 'teardown', this.cleanup );
        this.render();
    },
    render: function(){
        var data = this.model.toJSON();
        data.active = data.name == this.options.selection;
        var item = swatchTemplate( data );
        this.el.innerHTML = item;
    },
    cleanup: function(){
        this.model.destroy();
        
    }
    
});
export { SwatchView };